export const CategorymCardData = [
    {
        id: "0",
        title: "All",
        cardImage: "/images/card-1.jpeg",
    },
    {
        id: "1",
        title: "Jeans",
        cardImage: "/images/card-2.jpeg",
    },
    {
        id: "2",
        title: "jackets",
        cardImage: "/images/card-3.jpeg",
    },
    {
        id: "3",
        title: "Shirts",
        cardImage: "/images/card-4.jpeg",
    },
    {
        id: "4",
        title: "trousers",
        cardImage: "/images/card-5.jpeg",
    },
    {
        id: "5",
        title: "t-shirts",
        cardImage: "/images/card-6.jpeg",
    },
    {
        id: "6",
        title: "formal pants",
        cardImage: "/images/card-7.jpeg",
    },
    {
        id: "7",
        title: "formal",
        cardImage: "/images/card-8.jpeg",
    },
    {
        id: "8",
        title: "joggers",
        cardImage: "/images/card-9.jpeg",
    },
    {
        id: "9",
        title: "lower",
        cardImage: "/images/card-10.jpeg",
    },
    {
        id: "10",
        title: "garments",
        cardImage: "/images/card-1.jpeg",
    },

]